/*
  assets/hrc-diagnostic-scoring.js
  Motor de puntuacion HRC V1.0 (Prompt Maestro, seccion 10). Funciones puras.
  CORRECCION (auditoria P0-5): fortalezas empatadas -- antes se elegia una
  sola con sort()[0], ignorando que el propio documento pide "no seleccionar
  arbitrariamente una sola" cuando hay empate o diferencia <=0.10. Ahora se
  devuelve `strongestAreas` (array) ademas de `strongestArea` (compatibilidad).
  No se toca ninguna formula de puntuacion aprobada: mismo area_score,
  general_score, capas, cuello de botella, equilibrio, indice de prioridad,
  alertas, consejos y acciones que ya estaban implementados.
*/
(function () {
  'use strict';

  var CFG = window.HRC_DIAGNOSTIC_CONFIG;
  var STRENGTH_TIE_MARGIN = 0.10;

  function round1(n) { return Math.round(n * 10) / 10; }
  function round2(n) { return Math.round(n * 100) / 100; }

  function levelFromScore(score5) {
    var levels = CFG.levels;
    for (var i = 0; i < levels.length; i++) {
      if (score5 >= levels[i].min && score5 <= levels[i].max) return levels[i];
    }
    return score5 < levels[0].min ? levels[0] : levels[levels.length - 1];
  }

  function score100(score5) { return Math.round(((score5 - 1) / 4) * 100); }

  // ---- Puntuacion por area -------------------------------------------------
  function computeAreaScores(areas, answers) {
    return areas.map(function (area) {
      var values = area.questions.map(function (q) { return answers[q.id]; });
      var sum = values.reduce(function (s, v) { return s + (v || 0); }, 0);
      var avg = sum / area.questions.length;
      var min = Math.min.apply(null, values);
      var max = Math.max.apply(null, values);
      var ones = values.filter(function (v) { return v === 1; }).length;
      var onesAndTwos = values.filter(function (v) { return v <= 2; }).length;
      return {
        key: area.key,
        label: area.label,
        questions: area.questions,
        answers: values,
        score: round2(avg),
        level: levelFromScore(avg),
        range: max - min,
        ones: ones,
        onesAndTwos: onesAndTwos,
        hasCriticalAnswer: ones > 0 || onesAndTwos >= 2
      };
    });
  }

  function computeGeneralScore(areaScores) {
    var sum = areaScores.reduce(function (s, a) { return s + a.score; }, 0);
    return round2(sum / areaScores.length);
  }

  // ---- Capas transversales --------------------------------------------------
  function computeLayerScores(areas, answers) {
    return CFG.layerOrder.map(function (layer) {
      var qs = [];
      areas.forEach(function (area) {
        var q = area.questions.filter(function (q) { return q.layer === layer; })[0];
        if (q) qs.push(q);
      });
      var sum = qs.reduce(function (s, q) { return s + (answers[q.id] || 0); }, 0);
      return { layer: layer, score: round2(sum / qs.length), questions: qs };
    });
  }

  function detectBottleneck(layerScores) {
    var ordered = CFG.layerOrder.map(function (l) {
      return layerScores.filter(function (ls) { return ls.layer === l; })[0];
    });
    for (var i = 0; i < ordered.length - 1; i++) {
      var current = ordered[i];
      var next = ordered[i + 1];
      if (current.score < CFG.bottleneck.scoreCeiling && (next.score - current.score) >= CFG.bottleneck.minGapVsNextLayer) {
        return { type: 'clear', layer: current.layer, score: current.score };
      }
    }
    var lowest = layerScores.slice().sort(function (a, b) { return a.score - b.score; })[0];
    return { type: 'combined_pattern', layer: lowest.layer, score: lowest.score };
  }

  // ---- Equilibrio -------------------------------------------------------
  function areaBalanceLabel(range) {
    if (range <= 1) return 'equilibrada';
    if (range === 2) return 'irregular';
    return 'muy_desequilibrada';
  }

  function computeGlobalBalance(areaScores) {
    var scores = areaScores.map(function (a) { return a.score; });
    var diff = round2(Math.max.apply(null, scores) - Math.min.apply(null, scores));
    var label = 'equilibrado';
    if (diff >= 1.20) label = 'muy_desigual';
    else if (diff >= 0.60) label = 'diferencias_moderadas';
    return { difference: diff, label: label };
  }

  // ---- Indice de prioridad -----------------------------------------------
  function criticalityScore(area) {
    if (area.ones >= 1 && area.onesAndTwos >= 2) return CFG.criticality.oneAnswer1AndAnotherLte2;
    if (area.ones >= 1) return CFG.criticality.oneAnswer1;
    var twos = area.answers.filter(function (v) { return v === 2; }).length;
    if (twos >= 2) return CFG.criticality.twoOrMoreAnswer2;
    if (twos === 1) return CFG.criticality.oneAnswer2;
    return CFG.criticality.none;
  }

  function goalMatchScore(area, audience, goal) {
    if (!goal) return CFG.goalMatch.none;
    var GOAL_AREA_MAP = {
      'entender-juego': ['player_game_understanding'],
      'mejorar-posicion': ['player_technical_tactical', 'player_physical_preparation'],
      'fisico': ['player_physical_preparation'],
      'mentalidad': ['player_mental_performance'],
      'dar-salto': ['player_technical_tactical', 'player_physical_preparation', 'player_mental_performance'],
      'definir-modelo': ['coach_game_model'],
      'mejorar-tareas': ['coach_methodology_tasks'],
      'planificar-mejor': ['coach_planning'],
      'analizar-mejor': ['coach_analysis_evaluation'],
      'liderar-comunicar': ['coach_leadership_communication'],
      'optimizar-proceso': ['coach_planning', 'coach_methodology_tasks']
    };
    var direct = GOAL_AREA_MAP[goal] || [];
    if (direct.length && direct[0] === area.key) return CFG.goalMatch.direct;
    if (direct.indexOf(area.key) !== -1) return CFG.goalMatch.partial;
    return CFG.goalMatch.none;
  }

  function computePriorityIndex(areaScores, audience, goal) {
    return areaScores.map(function (area) {
      var need = ((5 - area.score) / 4) * 100;
      var criticality = criticalityScore(area);
      var goalM = goalMatchScore(area, audience, goal);
      var context = 0; // seccion 10: "solo resuelve diferencias pequenas" -- desempate, no altera el indice base.
      var w = CFG.priorityWeights;
      var index = (need * w.need) + (criticality * w.criticality) + (goalM * w.goalMatch) + (context * w.context);
      return { key: area.key, label: area.label, index: round2(index), need: round1(need), criticality: criticality, goalMatch: goalM, area: area };
    }).sort(function (a, b) { return b.index - a.index; });
  }

  function pickPriorities(priorityIndexList) {
    var sorted = priorityIndexList; // ya ordenado desc
    var p1 = sorted[0];
    var p2 = sorted[1];
    var connected = p2 ? (p1.index - p2.index) < CFG.connectedPriorities.maxGap : false;
    var showSecond = false;
    if (p2) {
      var a = p2.area;
      showSecond = a.score < CFG.secondPriority.scoreCeiling || a.hasCriticalAnswer || p2.goalMatch === CFG.goalMatch.direct;
    }
    return { priority1: p1, priority2: showSecond ? p2 : null, connected: connected && showSecond };
  }

  // ---- Alertas --------------------------------------------------------------
  var INJURY_KEYWORDS = ['molestia', 'lesion', 'lesión', 'dolor', 'daño', 'daño físico', 'no puedo mover', 'me duele'];

  function detectAlert(audience, answers, perceivedLimitation, freeText, areaScores) {
    if (audience !== 'player') {
      return { active: false, coachGuidance: 'no_generar_prescripciones_fisicas_automaticas' };
    }
    var reasons = [];
    if (answers['J-HR-05'] === 1) reasons.push('J-HR-05=1');
    if (perceivedLimitation === 'recuperacion_molestias') reasons.push('percepcion_recuperacion_molestias');

    var physical = areaScores.filter(function (a) { return a.key === 'player_physical_preparation'; })[0];
    var habits = areaScores.filter(function (a) { return a.key === 'player_habits_availability'; })[0];
    if (physical && habits && physical.score < CFG.bottleneck.scoreCeiling && habits.score < CFG.bottleneck.scoreCeiling) {
      reasons.push('combinacion_critica_fisico_recuperacion');
    }
    if (freeText) {
      var lower = freeText.toLowerCase();
      if (INJURY_KEYWORDS.some(function (k) { return lower.indexOf(k) !== -1; })) reasons.push('texto_libre_molestia');
    }
    if (!reasons.length) return { active: false };
    return {
      active: true,
      reasons: reasons,
      guidance: {
        noRecommendIntensePhysical: true,
        noPrescribeOrDiagnose: true,
        prioritizeCommunicationOrAssessment: true,
        blockPhysicalProductAsMain: true
      }
    };
  }

  // ---- Percepcion vs resultado ------------------------------------------
  function perceptionVsResult(priority1, perceivedLimitation, audience) {
    var M = CFG.perceptionMatch;
    if (!perceivedLimitation || perceivedLimitation === 'no_claro' || perceivedLimitation === 'otro') return M.UNCLEAR;
    var LIMITATION_AREA_MAP = {
      comprension: 'player_game_understanding',
      entrenamiento_especifico: 'player_technical_tactical',
      constancia: 'player_habits_availability',
      presion: 'player_mental_performance',
      confianza: 'player_mental_performance',
      fisico: 'player_physical_preparation',
      recuperacion_molestias: 'player_habits_availability',
      modelo_no_definido: 'coach_game_model',
      trasladar_tareas: 'coach_methodology_tasks',
      continuidad_planificacion: 'coach_planning',
      analisis_estructura: 'coach_analysis_evaluation',
      analisis_decisiones: 'coach_analysis_evaluation',
      comunicacion_liderazgo: 'coach_leadership_communication',
      tiempo_recursos: M.EXTERNAL_LIMITATION
    };
    var mapped = LIMITATION_AREA_MAP[perceivedLimitation];
    if (mapped === M.EXTERNAL_LIMITATION) return M.EXTERNAL_LIMITATION;
    if (!mapped) return M.UNCLEAR;
    if (mapped === priority1.key) return M.FULL_MATCH;
    return M.RELEVANT_DIFFERENCE;
  }

  // ---- Consejos (uno por area) -------------------------------------------
  function pickAdviceForArea(area) {
    var qs = area.questions;
    var minScore = Math.min.apply(null, area.answers);
    var candidates = qs.filter(function (q, i) { return area.answers[i] === minScore; });
    if (minScore >= 4) {
      var last = qs[qs.length - 1];
      return { question: last, refinement: true };
    }
    if (candidates.length > 1) {
      candidates.sort(function (a, b) { return CFG.layerOrder.indexOf(a.layer) - CFG.layerOrder.indexOf(b.layer); });
    }
    var chosen = candidates[0];
    var safety = qs.filter(function (q) { return q.alert; });
    if (safety.length && area.answers[qs.indexOf(safety[0])] <= 2) chosen = safety[0];
    return { question: chosen, refinement: false };
  }

  function buildAdvice(areaScores) {
    return areaScores.map(function (area) {
      var pick = pickAdviceForArea(area);
      return { areaKey: area.key, areaLabel: area.label, questionId: pick.question.id, advice: pick.question.advice, refinement: pick.refinement };
    });
  }

  // ---- Acciones (maximo 3) ------------------------------------------------
  function lowestQuestionOf(area, excludeIds) {
    excludeIds = excludeIds || [];
    var pairs = area.questions.map(function (q, i) { return { q: q, v: area.answers[i] }; })
      .filter(function (p) { return excludeIds.indexOf(p.q.id) === -1; });
    pairs.sort(function (a, b) { return a.v - b.v; });
    return pairs[0];
  }

  function buildActions(priorities, bottleneck, alert, goal) {
    var actions = [];
    var usedIds = [];
    var areaCount = {};

    function push(question, area, reason) {
      if (!question || usedIds.indexOf(question.q.id) !== -1) return false;
      var count = areaCount[area.key] || 0;
      if (count >= 2) return false;
      actions.push({ questionId: question.q.id, action: question.q.action, areaKey: area.key, areaLabel: area.label, reason: reason });
      usedIds.push(question.q.id);
      areaCount[area.key] = count + 1;
      return true;
    }

    var p1Area = priorities.priority1.area;
    var first = lowestQuestionOf(p1Area, usedIds);
    push(first, p1Area, 'pregunta_mas_baja_prioridad_principal');

    var second = lowestQuestionOf(p1Area, usedIds);
    var secondIsCritical = second && second.v <= 2;
    var secondDifferentLayer = second && bottleneck && second.q.layer !== bottleneck.layer;
    if (second && (secondIsCritical || secondDifferentLayer)) {
      push(second, p1Area, 'segunda_necesidad_prioridad_principal');
    } else if (priorities.priority2) {
      var p2Low = lowestQuestionOf(priorities.priority2.area, usedIds);
      push(p2Low, priorities.priority2.area, 'segunda_prioridad');
    }

    if (actions.length < 3) {
      if (priorities.priority2) {
        var p2Candidate = lowestQuestionOf(priorities.priority2.area, usedIds);
        push(p2Candidate, priorities.priority2.area, 'segunda_prioridad');
      }
    }
    if (actions.length < 3 && alert && alert.active) {
      var hrArea = p1Area.key === 'player_habits_availability' ? p1Area : null;
      if (hrArea) push(lowestQuestionOf(hrArea, usedIds), hrArea, 'alerta');
    }

    return actions.slice(0, 3);
  }

  // ---- Calidad orientativa ------------------------------------------------
  function computeQuality(answers, questionIds, elapsedSeconds) {
    var values = questionIds.map(function (id) { return answers[id]; });
    var answered = values.filter(function (v) { return typeof v === 'number'; }).length;
    if (answered < questionIds.length) return { flag: null, complete: false };
    var distinct = {};
    values.forEach(function (v) { distinct[v] = (distinct[v] || 0) + 1; });
    var distinctCount = Object.keys(distinct).length;
    var maxRepeat = Math.max.apply(null, Object.keys(distinct).map(function (k) { return distinct[k]; }));
    var sameRatio = maxRepeat / values.length;
    var flags = [];
    if (distinctCount < CFG.qualityCriteria.minDistinctValues) flags.push(CFG.qualityFlags.LOW_DIFFERENTIATION);
    if (sameRatio >= CFG.qualityCriteria.maxSameAnswerRatio) flags.push(CFG.qualityFlags.LOW_DIFFERENTIATION);
    if (typeof elapsedSeconds === 'number' && elapsedSeconds < CFG.qualityCriteria.minReasonableSeconds) flags.push(CFG.qualityFlags.TOO_FAST);
    return { flag: flags.length ? flags[0] : CFG.qualityFlags.ADEQUATE, complete: true };
  }

  // ---- Orquestador --------------------------------------------------------
  function computeFullResult(input) {
    var areaScores = computeAreaScores(input.areas, input.answers);
    var generalScore = computeGeneralScore(areaScores);
    var layerScores = computeLayerScores(input.areas, input.answers);
    var bottleneck = detectBottleneck(layerScores);
    var globalBalance = computeGlobalBalance(areaScores);
    var priorityIndexList = computePriorityIndex(areaScores, input.audience, input.goal);
    var priorities = pickPriorities(priorityIndexList);

    // P0-5: fortalezas compartidas cuando el margen es <=0.10 respecto al maximo.
    var maxScore = Math.max.apply(null, areaScores.map(function (a) { return a.score; }));
    var strongestAreas = areaScores.filter(function (a) { return (maxScore - a.score) <= STRENGTH_TIE_MARGIN; })
      .sort(function (a, b) { return b.score - a.score; })
      .map(function (a) { return { key: a.key, label: a.label, score: a.score }; });

    var alert = detectAlert(input.audience, input.answers, input.perceivedLimitation, input.freeText, areaScores);
    var perception = perceptionVsResult(priorities.priority1, input.perceivedLimitation, input.audience);
    var advice = buildAdvice(areaScores);
    var actions = buildActions(priorities, bottleneck.type === 'clear' ? bottleneck : null, alert, input.goal);
    var allQuestionIds = input.areas.reduce(function (acc, a) { return acc.concat(a.questions.map(function (q) { return q.id; })); }, []);
    var quality = computeQuality(input.answers, allQuestionIds, input.elapsedSeconds);

    return {
      version: CFG.versions.scoring,
      audience: input.audience,
      generalScore: generalScore,
      generalScore100: score100(generalScore),
      generalLevel: levelFromScore(generalScore),
      areaScores: areaScores.map(function (a) {
        return { key: a.key, label: a.label, score: a.score, score100: score100(a.score), level: a.level, balance: areaBalanceLabel(a.range), hasCriticalAnswer: a.hasCriticalAnswer };
      }),
      layerScores: layerScores,
      bottleneck: bottleneck,
      globalBalance: globalBalance,
      strongestArea: strongestAreas[0],
      strongestAreas: strongestAreas,
      priority1: { key: priorities.priority1.key, label: priorities.priority1.label, index: priorities.priority1.index },
      priority2: priorities.priority2 ? { key: priorities.priority2.key, label: priorities.priority2.label, index: priorities.priority2.index } : null,
      connectedPriorities: priorities.connected,
      alert: alert,
      perception: perception,
      advice: advice,
      actions: actions,
      quality: quality
    };
  }

  window.HRC_DIAGNOSTIC_SCORING = {
    computeFullResult: computeFullResult,
    levelFromScore: levelFromScore,
    score100: score100
  };
})();
